// Facilities map

import addGoogleMap from '../../scripts/app/google-map';

addGoogleMap('.jsFacilitiesMap');

// Enable tabbable tabs via JS

$(function () {
  $('.TabPanel .nav-tabs').on('click', 'a', function (e) {
    e.preventDefault();
    const tabLink = $(this);
    const tabIndex = tabLink.parent().index();
    const tabPanel = $(this).closest('.TabPanel');
    const tabPane = tabPanel.find('.tab-pane').eq(tabIndex);

    tabPanel.find('.active').removeClass('active show');
    tabLink.addClass('active');
    tabPane.addClass('active show');
  });
});
